import React from 'react';
import { DragOverlay, DndContext, pointerWithin } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';

import { getTranslation } from 'helpers/getTranslation';

import { Icon } from 'components/shared/Icon';
import { Button } from 'components/shared/Button';
import { Typography } from 'components/shared/Typography';

import { DragMenu } from 'components/DragMenu';
import { SortableItem } from 'components/SortableItem';

import { Answer } from '../Answer';

import styles from './Answers.module.scss';

const Answers = ({
  readOnly,
  answers,
  answersType,
  namePrefix,
  sensors,
  activeDragAnswer,
  activeDragAnswerIndex,
  onAnswerDragStart,
  onAnswerDragEnd,
  onAnswerDragOver,
  onAddAnswerClick,
  onRemoveAnswerClick,
}: {
  readOnly: any;
  answers: any;
  answersType: any;
  namePrefix: any;
  sensors: any;
  activeDragAnswer: any;
  activeDragAnswerIndex: any;
  onAnswerDragStart: any;
  onAnswerDragEnd: any;
  onAnswerDragOver: any;
  onAddAnswerClick: any;
  onRemoveAnswerClick: any;
}) => (
  <>
    <Typography
      className={styles.title}
      variant="body1"
      weight="medium"
      mode="compact"
    >
      {getTranslation('quiz_page.answers.title')}
    </Typography>
    <div className={styles.inner}>
      <div className={styles.answers}>
        <DndContext
          sensors={sensors}
          collisionDetection={pointerWithin}
          onDragStart={onAnswerDragStart}
          onDragEnd={onAnswerDragEnd}
          onDragOver={onAnswerDragOver}
        >
          <SortableContext items={answers} strategy={() => null}>
            {answers.map((answer: any, answerIndex: any) => (
              <SortableItem
                className={styles.answer}
                key={answer.id}
                id={answer.id}
              >
                {({ listeners }: { listeners: any }) => (
                  <>
                    {!readOnly && (
                      <DragMenu
                        className={styles.answerMenu}
                        dragListeners={listeners}
                        onRemoveClick={() => onRemoveAnswerClick(answer.id)}
                      />
                    )}
                    <Answer
                      readOnly={readOnly}
                      order={answerIndex + 1}
                      answersType={answersType}
                      namePrefix={`${namePrefix}.answers[${answerIndex}]`}
                    />
                  </>
                )}
              </SortableItem>
            ))}
          </SortableContext>
          <DragOverlay>
            {activeDragAnswer ? (
              <Answer
                readOnly
                {...activeDragAnswer}
                order={activeDragAnswerIndex + 1}
                answersType={answersType}
                namePrefix={`${namePrefix}.answers[${activeDragAnswerIndex}]`}
              />
            ) : null}
          </DragOverlay>
        </DndContext>
      </div>
    </div>
    <div className={styles.divider} />
    {!readOnly && (
      <Button
        className={styles.addBtn}
        size="sm"
        variant="link"
        startIcon={<Icon name="plus" />}
        onClick={onAddAnswerClick}
      >
        {getTranslation('common.button.add_answer')}
      </Button>
    )}
  </>
);

export default React.memo(Answers) as any;
